import React from 'react';
import { DataList } from 'components/select-advanced';

const BillToPartySelect = (props: any) => {
	const {
		billToParty,
		optionsData,
		onBillToPartyDropDownChange,
		hasError,
		errorMsg,
		isDisabled,
		showLabel = true,
	} = props;

	return (
		<React.Fragment>
			<DataList
				id="billToPartyDropDown"
				className="billToPartyDropDown"
				label={showLabel ? 'Bill To Party' : ''}
				value={billToParty}
				data={optionsData}
				isDisabled={isDisabled}
				onChange={(e) => {
					onBillToPartyDropDownChange(e);
				}}
				hasError={hasError}
                error={errorMsg}
			/>
		</React.Fragment>
	);
};

export default BillToPartySelect;